<template>
  <div class="tender-result">
    <div class="result-top">
      <div class="top-left">
        <!-- <span class="btn-span" v-has="'02010053'">
          <el-button type="primary" @click="pushResult" :loading="pushLoad">推送价格表盖章</el-button>
        </span> -->
        <span class="btn-span" v-has="'02010054'">
          <el-button class="bigData-btn-mip" type="primary" @click="approveConsequence">招标结果审批</el-button>
        </span>
        <span class="btn-span" v-has="'02010055'">
          <el-button class="bigData-btn-repush" type="primary" @click="contractPush" :loading="loadRefresh">合同重推</el-button>
        </span>
        <span class="btn-span" v-has="'02010067'">
          <el-button class="bigData-btn-fail" type="primary" @click="gameOver" :disabled="loginState.bidStatus!=='30'">流标</el-button>
        </span>
        <span class="btn-span">
          <el-button class="bigData-btn-repush" type="primary" @click="onImport" :loading="importLoading">导入降本信息</el-button>
        </span>
        <span class="btn-span">
          <el-button class="bigData-btn-repush" type="primary" @click="onUpload">招标附件上传</el-button>
        </span>
        <!-- 80 完成决标 -->
        <span class="btn-span" v-if="loginState.bidStatus==='80'">
          <el-button class="bigData-btn-repush" type="primary" @click="onProgressQuery">合同进度查询</el-button>
        </span>
      </div>
      <div class="top-right">
        <span class="text">对比历史价格</span>
        <span class="number-history">{{compareHistory}}</span>
        <span class="text">对比拦标价格</span>
        <span class="number-bid">{{fieldmarkRange}}</span>
        <span v-has="'02010056'">
          <el-button class="bigData-btn-export" type="primary" icon="el-icon-upload" :loading="exportLoading" @click="exportDetail">导出</el-button>
        </span>
      </div>
    </div>
    <div class="result-table">
      <vbtTable
        v-loading="loading"
        ref="topicTable"
        :data="tableData"
        isBigData
        height="670"
        style="width: 100%;"
        element-loading-spinner="el-icon-loading"
        element-loading-text="列表加载中"
        border>
        <vbt-table-column :label="'序号'" prop="rowNumber"  width="50" align="center"></vbt-table-column>
        <template v-if="true" v-for="(item,index) in columnsList">
          <vbt-table-column v-if="true" :key="item.prop" :label="item.lable" :width="item.width">
            <template slot-scope="scope">
              <span
                class="caret"
                v-if="index===0&&!scope.row.quoteCodeParent"
                @click.stop="showDetail(scope.row)"
              >
                <i class="el-icon-caret-right" v-if="!scope.row.showSubTable"></i>
                <i class="el-icon-caret-bottom" v-if="scope.row.showSubTable"></i>
              </span>
              <span>{{ scope.row[item.prop]}}</span>
            </template>
          </vbt-table-column>
        </template>
      </vbtTable>
    </div>
    <upload-dialog ref="uploadDialog" :bidNo="bidNo" tempTitle="招标附件上传" />
    <import-dialog ref="importDialog" @reload="loadData" :exportTemplate="exportTemplate" :bidNo="bidNo" tempTitle="导入降本信息" uploadPath="/bid/quoteTemplate/importCostReduction" />
  </div>
</template>
<script>
import { 
  getTableList,
  getTableListChildList, 
  pushResultStamp, 
  approveBidConsequence, 
  refreshPush, bidders, 
  bidQuoteExport,
  costReductionDownloadTpl } from '../../../api/tenderResult';
import { dictWithUrl } from '@/components/lots/api';
import bigDataLog from '@/utils/bigDataLog';
import ImportDialog from "./ImportDialog";
import UploadDialog from "./UploadDialog";
import { vbtTable, vbtTableColumn } from 'vbt-table';
// import configs from '@/config/user.env';
import { mapGetters } from 'vuex';
// import { SRM_FILE_PRE } from '../../../constant/constant.js';
export default {
    components: { vbtTable, vbtTableColumn,ImportDialog,UploadDialog },
    data() {
        return {
            pushLoad: false,
            exportLoading: false,
            exportTemplate: costReductionDownloadTpl,
            loadRefresh: false,
            importLoading: false,
            overBtn: false,
            bidNo: '',
            dictData: [],
            compareHistory: 0,
            fieldmarkRange: 0,
            loading: true,
            tableData: [],
            fixedList: [
                { lable: '降本率（%）', prop: 'costReductionRate', width: '100px' },
                { lable: '预计降本额（元）', prop: 'preCostReductionAmount', width: '140px' },
                { lable: '采购毛利率（%）', prop: 'purchaseGrossMargin', width: '130px' },
                { lable: '预计业务量', prop: 'expectTraffic', width: '100px' },
                { lable: '单价', prop: 'unitPrice', width: '80px' },
                { lable: '总费用', prop: 'lineAmountTotal', width: '100px' },
                { lable: '中标状态', prop: 'shortlistText', width: '80px' },
                { lable: '中标供应商', prop: 'supplierName', width: '130px' },
                { lable: '供应商总运量占比', prop: 'allSupplierRation', width: '130px' },
                { lable: '运作保证金', prop: 'operatingMargin', width: '100px' },
                { lable: '退线违约金', prop: 'pushingPenalty', width: '100px' },
                { lable: '历史价格', prop: 'historyPrice', width: '100px' },
                { lable: '历史总费用', prop: 'historyPriceSum', width: '120px' },
                { lable: '对比历史价格', prop: 'historyDrop', width: '110px' },
                { lable: '老供应商', prop: 'formerSupplierName', width: '100px' }
            ],
            columnsList: [],
            TodoPath: '',
            iflowId: this.$route.query.mbpmFlowId,
        };
    },
    computed: {
        ...mapGetters(['currentTenant', 'applicationCode', 'tenantCode']),
        loginState: function() {
            return this.$store.state.bidData;
        },
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.TodoPath = from.name;
        });
    },
    methods: {
      onProgressQuery(){
        this.$router.push({
                        name: 'contractUphold',
                        query: {
                          tenderCode: this.bidNo,
                        }
                    });
        bigDataLog.sendDetailMessageByNames(`招标维护,招标结果,,合同进度查询`);
      },
      onUpload(){
        this.$refs.uploadDialog.handleVisible(true);
      },
      onImport() { // 导入降本信息成功
            this.$refs.importDialog.handleVisible(true);
            bigDataLog.sendDetailMessageByNames(`招标维护,招标结果,,导入降本信息`);
        },
        loadData(){
            this.getTableData();
        },
        getTableData() {
            // 获取表头和列表
            getTableList({ bidNo: this.bidNo, iflowId: this.iflowId }).then(res => {
                if (res && res.code === '0') {
                    this.compareHistory = res.data.compareHistory;
                    this.fieldmarkRange = res.data.fieldmarkRange;
                    this.tableData = res.data.tenderList;
                    let rowNumber = 0;
                    this.tableData.forEach(item => {
                        item.historyPrice = undefined;
                        rowNumber++;
                        item.rowNumber = rowNumber;
                        if(typeof item.costReductionRate==="number"){//降本率
                            item.costReductionRate=item.costReductionRate.toFixed(2); 
                        }
                        if(typeof item.preCostReductionAmount==="number"){//预计降本额
                            item.preCostReductionAmount=item.preCostReductionAmount.toFixed(2); 
                        }
                        if(typeof item.purchaseGrossMargin==="number"){//采购毛利率
                            item.purchaseGrossMargin=item.purchaseGrossMargin.toFixed(2); 
                        }
                        this.$set(item, 'showSubTable', false);
                        // if (item.childList) {
                        //     item.childList.forEach(it => {
                        //         rowNumber++;
                        //         it.rowNumber = rowNumber;
                        //     });
                        // }
                    });
                    this.formatData(this.tableData);
                    this.columnsList = res.data.templateList;
                    this.fixedList.forEach(item => {
                        this.columnsList.push(item);
                    });
                    setTimeout(() => {
                        this.loading = false;
                    }, 1000);
                }
            });
        },
        // 对排序号进行排序
        // compare(property) {
        //     return function(value1, value2) {
        //         const v1 = value1[property];
        //         const v2 = value2[property];
        //         return v1 - v2;
        //     };
        // },
        /** 导出 **/
        exportDetail() {
            // let apiUrl = '';
            // if (window.location.origin !== 'http://localhost.midea.com:8080') {
            //     apiUrl = configs.apiUrl;
            // }
            // window.location =
            //     apiUrl +
            //     `${SRM_FILE_PRE}/bid/bidQuoteTemplate/bidQuoteExportListExport/` +
            //     this.bidNo;
            this.exportLoading = true;
            bidQuoteExport(this.bidNo).then(res => {
                if (res) {
                    const blob = new Blob([res], {
                        // type: 'application/x-excel;charset=UTF-8'
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    const objectUrl = URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = objectUrl;
                    a.download = this.loginState.bidName + '-招标结果明细.xlsx';
                    a.click();
                    this.$message.success('导出成功');
                }
            }).finally(() => { this.exportLoading = false; });
        },
        /** 推送价格表盖章 **/
        pushResult() {
            this.pushLoad = true;
            pushResultStamp({ bidNo: this.bidNo }).then(res => {
                this.pushLoad = false;
                if (res && res.code === '0') {
                    this.$message.success('推送成功');
                }
            });
        },
        /** 招标结果审批 **/
        approveConsequence() {
            let strUrl = '';
            strUrl = location.origin + location.pathname + location.hash;
            const params = {
                tenantCode: this.currentTenant.tenantCode,
                appCode: this.applicationCode,
                fdTemplateCode: 'srm_quote_bpm',
                loginName: this.$store.getters.user.userCode,
                formParam: {
                    subject: this.$route.query.bidNo + '_' + this.loginState.bidName + '_招标结果审批_' + this.$store.getters.user.userName,
                    formInstanceId: new Date().getTime(),
                    fdUrl: strUrl
                }
            };
            approveBidConsequence(this.bidNo, params).then(res => {
                if (res && res.code === '0') {
                    this.$router.push({
                        name: 'mipIframe',
                        query: {
                            isBack: true,
                            path: 'tenderresult',
                            mbpmFlowId: this.iflowId,
                            processId: res.data,
                            formInstanceId: this.bidNo,
                            accuratePosition:'tenderResult'
                        }
                    });
                }
            });
        },
        formatData(data) {
            data.map(item => {
                item.shortlistText = this.dictData.BID_WON_STATUS[item.shortlist];
            });
            return data;
        },
        async contractPush() {
            // 合同重推
            this.loadRefresh = true;
            const res = await refreshPush({ bidNo: this.bidNo });
            this.loadRefresh = false;
            if (res && res.data.code === '0') {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
            }
        },
        gameOver() {
            // 流标
            this.$confirm('是否确定流标？', '流标确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            })
                .then(async () => {
                    const res = await bidders({ bidNo: this.bidNo });
                    if (res && res.code === '0') {
                        this.$message.success('操作成功');
                    }
                })
                .catch(() => {});
        },
        async showDetail(row) {
            row.showSubTable = !row.showSubTable;
            const index = this.tableData.indexOf(row);
            await this.loadChildList(row);
            if (row.showSubTable) {
                // 展开
                this.tableData.splice(index + 1, 0, ...row.childList);
            } else {
                // 缩回
                this.tableData.splice(index + 1, row.childList.length);
            }
        },
        async loadChildList(row) {
            if (row.childList) return;
            this.loading = true;

            const res = await getTableListChildList({ bidNo: this.bidNo, quoteCode: row.quoteCode });
            if (!res || res.code !== '0' || !res.data) {
                return this.$message.warning('获取招标结果详情失败');
            }

            const childList = res.data;
            childList.forEach(it => {
                it.rowNumber = row.rowNumber;
            });

            row.childList = childList;

            this.loading = false;
        }
    },
    mounted() {
        this.bidNo = this.$route.query.bidNo;
        dictWithUrl('BID_WON_STATUS').then(res => {
            this.dictData = res.data;
            this.getTableData();
        });
        bigDataLog.sendDetailMessageByKey('bigData-btn-result');
    },
    watch: {
        TodoPath(val) {
            if (!val && this.$route.query.formInstanceId) {
                this.approveConsequence();
            }
        }
    }
};
</script>
<style lang="less">
.tender-result {
  margin-top: 20px;
  .result-top {
    display: flex;
    justify-content: space-between;
  }
  .top-right {
    display: flex;
    justify-content: center;
    align-items: center;
    .text {
      margin: 0 10px 0 30px;
      font-size: 12px;
    }
    .number-history {
      font-size: 12px;
      color: #008f21;
    }
    .number-bid {
      margin-right: 30px;
      font-size: 12px;
      color: #ff6464;
    }
  }
  .el-icon-upload2 {
    margin-right: 7px;
    font-size: 15px;
    color: #00bcbf;
  }
  .result-table {
    margin-top: 15px;
  }
  .cell {
    display: flex;
      .post-input div:first-child{
      display: flex
  }
  .el-input-group__append{display: flex}
  }
  .btn-span {
    margin-right: 10px;
  }
  .caret {
    cursor: pointer;
  }
}
</style>